export default "__VITE_ASSET__Dzl3WOMC__"